var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login_manager"},[(_vm.loginComponent === 'login')?_c('Login'):(_vm.loginComponent === 'terms')?_c('Terms'):(_vm.loginComponent === 'regist')?_c('Regist'):(_vm.loginComponent === 'welcome')?_c('Welcome'):(_vm.loginComponent === 'findAccount')?_c('FindAccount'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dede0df","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/LoginManager.vue
// module id = 153
// module chunks = 0